/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCoreRouter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 16v6H2v-6zm14 0v6h-6v-6zm-7 0v6H9v-6zm-9 2H4v2h2zm14 0h-2v2h2zm-7 0h-2v2h2zm9-10v6H2V8zm-2 2H4v2h16zm-7-8v4h-2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCoreRouter as CoreRouter };
